define.alias("shared/components/shared/post-tagging/select/tag-select-multiple", "settings/components/shared/post-tagging/select/tag-select-multiple");